import { isBlank } from "../common/general";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

export const mapUploadFileData = (file, type = "SUBMISSION") => ({
  filename: file.name,
  fileType: type,
  mimeType: file.type,
  size: file.size,
});

export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return "0 Bytes";

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const useTimeRemaining = secs => {
  const { t } = useTranslation();
  const [timeRemaining, setTimeRemaining] = useState("");
  useEffect(() => {
    if (secs === 0 || isBlank(secs) || isNaN(secs)) {
      setTimeRemaining("");
    } else if (secs >= 60) {
      const minutes = Math.floor(secs / 60);
      setTimeRemaining(
        t("upload.time_remaining.minutes", {
          minutes: minutes,
          defaultValue: `${minutes} min remaining`,
        })
      );
    } else {
      setTimeRemaining(
        t("upload.time_remaining.seconds", {
          seconds: secs,
          defaultValue: `${secs} secs remaining`,
        })
      );
    }
  }, [secs, t]);

  return timeRemaining;
};
